/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnnualBudgetDto } from '../../models/annual-budget-dto';
import { AnnualBudgetFormDto } from '../../models/annual-budget-form-dto';

export interface UpdateAnnualBudgetByHours$Params {
  year: number;
      body: AnnualBudgetFormDto
}

export function updateAnnualBudgetByHours(http: HttpClient, rootUrl: string, params: UpdateAnnualBudgetByHours$Params, context?: HttpContext): Observable<StrictHttpResponse<AnnualBudgetDto>> {
  const rb = new RequestBuilder(rootUrl, updateAnnualBudgetByHours.PATH, 'put');
  if (params) {
    rb.path('year', params.year, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnnualBudgetDto>;
    })
  );
}

updateAnnualBudgetByHours.PATH = '/budget-management/{year}/by-hours';
